import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { ReactComponent as EditSVG } from 'core/assets/images/V2/icons/Edit.svg';
import { ReactComponent as FreezeSVG } from 'core/assets/images/V2/icons/FreezeIcon.svg';
import { PRODUCT_TEMP } from 'core/assets/images/V2';
import { Box, Button, Flex, Image } from 'core/ui/atoms';
import { productDescriptionPath } from 'onramp/api/navigation';

const OrderItem = ({ item, deliveryDayId }) => {
  const { name, subtitle, allergens, freezerFriendly, images, editable } = item;
  const history = useHistory();

  const onHandleDetails = () => {
    history.push(productDescriptionPath(deliveryDayId, item?.id));
  };

  const imageUrl = images?.length > 0 ? images[0].smallUrl : PRODUCT_TEMP;

  return (
    <ProductContainer>
      <SelectCont>
        <ProductImage src={imageUrl} alt={name} />
        {editable &&
          <EditBadge>
            <EditSVG />
          </EditBadge>
        }
        {freezerFriendly &&
          <FreezeBadge>
            <FreezeSVG />
          </FreezeBadge>
        }
      </SelectCont>
      <ItemContainer>
        <ProductName>{name}</ProductName>
        {subtitle && <ProductDescription>{subtitle}</ProductDescription>}
        {allergens &&
          <ProductAllergens alignItems="center">
            Allergens : {allergens.join(', ')}
          </ProductAllergens>
        }
        <DetailsButton btn-outline btn-lg onClick={onHandleDetails}>SEE DETAILS</DetailsButton>
      </ItemContainer>
    </ProductContainer>
  );
};

OrderItem.propTypes = {
  item: PropTypes.object.isRequired,
  deliveryDayId: PropTypes.string.isRequired,
};

const ItemContainer = styled(Box)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const ProductImage = styled(Image)`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const SelectCont = styled.div`
  position: relative;
  height: 250px;
  width: 250px;
  display: flex;
  justify-content: end;
  flex-shrink: 0;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`;

const EditBadge = styled(Box)`
  height: 20px;
  width: 45px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  position: absolute;
  top: 0rem;
  right: 0rem;
`;

const FreezeBadge = styled(Box)`
  height: 20px;
  width: 45px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  position: absolute;
  bottom: 0rem;
  left: 0rem;
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  &:first-child {
    margin-left: 15%;
  }
  &:last-child {
    margin-right: 15%;
  }
`;

const DetailsButton = styled(Button)`
  width: 160px;
  padding: 15px 32px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
`;

const ProductName = styled.p`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  height: 44px;
  margin-bottom: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

const ProductDescription = styled.p`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  color: ${(p) => p.theme.colors.primaryV2};
  margin-bottom: 20px;
`;

const ProductAllergens = styled(Flex)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 500;
  font-style: italic;
  font-size: 12px;
  text-align: center;
  margin-bottom: 30px;
  height: 24px;
`;

export default OrderItem;
